<template>
  <a-modal
    :title="modalTit"
    :visible="isLimitDialogShow"
    :ok-text="okTTxt"
    :cancel-text="cancelTxt"
    :width="btnShow? '692px': '672px'"
    :destroy-on-close="true"
    :mask-closable="false"
    :confirm-loading="confirmLoading"
    class="set-method-modal"
    @ok="formHandle"
    @cancel="cancelHanler"
  >
    <div
      class="alert-blue-title"
    >
      {{ $t('message["1535"]') }}
    </div>
    <div class="add-all-rule scroll_bar_beautify_ff">
      <a-form
        ref="createForm"
        :form="form"
        class="form"
        layout="inline"
      >
        <a-form-item
          :label="`${modalTit}：`"
        >
          <a-checkbox-group
            v-model="selectedKeys"
            @change="changeHandler"
          >
            <a-checkbox
              v-for="item in checkboxDatas"
              :key="item.value"
              :value="item.value"
              :disabled="item.dis"
              @change="checkboxHandler"
            >
              {{ item.label }}
            </a-checkbox>
            <a-checkbox
              v-if="itemData.leader && itemData.leader.length"
              :value="4"
              @change="checkboxHandler"
            >
              {{ $t('message["1674"]') }}
            </a-checkbox>
          </a-checkbox-group>
          <a-button
            v-if="btnShow"
            class="editlimit-btn"
            @click="editlimit"
          >
            {{ $t('message["39"]') }}
          </a-button>
          <edit-limit-dialog
            ref="editlimit"
            :item-data="itemData"
            @getLimitData="getLimitData"
          />
        </a-form-item>
      </a-form>
    </div>
  </a-modal>
</template>
<script>
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'
import EditLimitDialog from './EditLimitDialog'
export default {
  components: {
    EditLimitDialog
  },
  props: {
    itemData: {
      type: Object,
      default () {
      }
    }
  },
  data () {
    return {
      submiting: false,
      isLimitDialogShow: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      selectedKeys: this.itemData.divide_type || [],
      btnShow: false,
      checkboxDatas: [
        {
          label: this.$t('message["299"]'),
          dis: false,
          value: 1
        },
        {
          label: this.$i18n.t('message["714"]'),
          dis: false,
          value: 2
        },
        {
          label: this.$i18n.t('message["3"]'),
          dis: false,
          value: 3
        }
        // {
        //   label: '组长指派',
        //   dis: false,
        //   value: 4
        // }
      ],
      divide_dec: this.itemData.divide_desc || []
    }
  },
  computed: {
    ...mapState('config/allocationrule', ['selectedDatas']),
    ...mapGetters('config/allocationrule', ['editSelectedDatas']),
    cancelTxt () {
      return this.$t('message["896"]')
    },
    okTTxt () {
      return this.$t('message["926"]')
    },
    modalTit () {
      return this.$t('message["1716"]')
    }
  },
  watch: {
    isLimitDialogShow (b) {
      if (b) {
        // console.log(this.itemData)
        this.selectedKeys = this.itemData.divide_type || []
        this.divide_dec = this.itemData.divide_desc || []
        this.filterData(this.selectedKeys)
      }
    }
  },
  created () {
    // this.selectedKeys = this.itemData.divide_type
  },
  inject: ['reload'],
  methods: {
    ...mapActions('config/allocationrule', ['editAllocation', 'editMethod']),
    ...mapMutations('config/allocationrule', ['setActiveName']),
    changeVisible (isShow) {
      this.isLimitDialogShow = isShow
    },
    async formHandle () {
      const { selectedKeys, itemData } = this
      if (selectedKeys.length) {
        let obj = {
          groupid: itemData.groupid,
          divide_type: selectedKeys,
          divide_desc: this.divide_dec
        }
        if (selectedKeys.includes(3) && obj.divide_desc.length === 0) {
          // 按额度分配额度不能为空
          this.$message.warning(this.$i18n.t('message["4"]'))
        } else if (selectedKeys.includes(3) && (obj.divide_desc.length > 0) && (obj.divide_desc.length < itemData.member.count)) {
          // 成员额度不能为空
          this.$message.warning(this.$t('message["113"]'))
        } else {
          const chain = await this.editMethod()
          chain.params(obj)
            .onSuccess(raw => {
              this.btnShow = false
              this.isLimitDialogShow = false
              // 操作成功
              this.$message.success(this.$t('message["81"]') + '！')
              this.reload()
            })
            .fetch()
        }
      } else {
        // 至少设置一种分配方式
        this.$message.warning(this.$t('message["1612"]'))
      }
    },
    cancelHanler () {
      this.btnShow = false
      this.isLimitDialogShow = false
    },
    changeHandler (e) {
      // this.filterData(e)
      // console.log(e)
    },
    filterData (arr) {
      const { checkboxDatas } = this
      checkboxDatas.forEach(item => {
        item.dis = false
      })
      // let { btnShow } = this
      for (let i = 0; i < arr.length; i++) {
        const value = arr[i]
        if (value === 2) {
          checkboxDatas.forEach(item => {
            if (item.value === 3) {
              // item.dis = true
            }
          })
        } else if (value === 3) {
          this.btnShow = true
          // checkboxDatas.forEach(item => {
          //   if (item.value === 2) {
          //     item.dis = true
          //   }
          // })
        }
      }
    },
    checkboxHandler (e) {
      // const { checkboxDatas } = this
      const value = e.target.value
      const b = e.target.checked
      if (value === 2) {
        // checkboxDatas.forEach(item => {
        //   if (item.value === 3) {
        //     item.dis = b
        //   }
        // })
      } else if (value === 3) {
        this.btnShow = b
        // checkboxDatas.forEach(item => {
        //   if (item.value === 2) {
        //     item.dis = b
        //   }
        // })
      }
    },
    editlimit () {
      this.$refs.editlimit.changeVisible(true)
    },
    getLimitData (data) {
      this.divide_dec = data
    }
  }
}
</script>
<style lang="scss" scoped>
.alert-blue-title {
  background-color: #e8f4ff;
  color: #333;
  font-size: 14px;
  height: 40px;
  line-height: 40px;
  padding-left: 24px;
  margin: 0 -40px 32px;

}
.add-all-rule::v-deep {
  height: 106px;
  overflow-y: auto;
  margin-right: -10px;
  .ant-form-inline .ant-form-item {
    margin-bottom: 24px;
    display: block;
  }
  .ant-row:after {
    clear: both;
    content: '.';
    display: block;
    height: 0;
    visibility: hidden;
  }
  .ant-row {
    padding-left: 94px;
    .ant-form-item-label {
      float: left;
      width: 94px;
      margin-left: -94px;
      label {
        color: #666;
      }
    }
    .ant-form-item-control-wrapper {
      float: left;
      width: 100%;
    }
  }
  .editlimit-btn {
    margin-right: 0 !important;
  }
}
</style>
<style lang="scss">
.set-method-modal {
  .ant-modal-body {
    padding: 0 40px 16px;
  }
}
</style>
